import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Description } from './styles';

export function Header(): JSX.Element {
	return (
		<Row>
			<Col span={24}>
				<Description>
					<span>{I18n.get('Risk range')}</span>
				</Description>
			</Col>
		</Row>
	);
}
